import { useLocation } from 'react-router-dom';

import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';
import { getDomainFromPathname } from '@/shared/lib/helpers/get-domain-from-pathname.helper';

import { useUserIsPlant } from '../selectors/select-user';

/**
 * Domain from the route prefix, otherwise the user's default domain
 */
export const useIsPlant = (): boolean => {
	const { pathname } = useLocation();
	const isPlant = useUserIsPlant();
	const domain = getDomainFromPathname(pathname);

	if (!domain) {
		return isPlant;
	}

	return domain === USER_DOMAIN.INDUSTRIAL;
};
